import { z } from 'zod';
import { requestIdSchema, providerType, reportFileExtensionType } from '@repo/shared/types';
export var reportGenerateRequestBodySchema = z.object({
    requestId: requestIdSchema,
    providers: z.array(providerType),
    data: z.object({
        type: z.enum(['transfer']),
        format: reportFileExtensionType,
        filters: z
            .object({
            dateFrom: z.string().nullable(),
            dateTo: z.string().nullable(),
        })
            .nullable(),
        async: z.boolean(),
    }),
});
